/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedBlurbShipping_shipmentQuote$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarBlurbs_shipmentQuote$ref: FragmentReference;
export type PdpRespSidebarBlurbs_shipmentQuote = {|
  +$fragmentRefs: PdpSharedBlurbShipping_shipmentQuote$ref,
  +$refType: PdpRespSidebarBlurbs_shipmentQuote$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_shipmentQuote",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '85984b8f55bab7b2541761aca530b253';
module.exports = node;
